import {
    generateDefaultState,
    getActionTypes,
} from '../../../utils/reduxHelper';

export const actions = getActionTypes('siteGroup', [
    'GET_ALL',
    'UPDATE',
    'CREATE',
    'DELETE',
]);

export const initialSiteGroupState = {
    ...generateDefaultState('siteGroup', [
        'GET_ALL',
        'UPDATE',
        'CREATE',
        'DELETE',
    ]),
};